/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/**
 * Adds common input pre-processing for filter functions.
 *
 * @param input {string} - value to filter on.
 * @param caseSensitive {boolean} - optional, defaults to false.
 * @param filterFn {Function} - array filter function to call
 * @returns {Function} - new array filter function with common pre-processing
 */
function createFilter(input = '', caseSensitive = false, filterFn) {
	return function(value = '') {
		// value could be a string or an object from a comboBox - { value, label }
		value = typeof value === 'string' ? value : value.label || '';
		input = input.trim();

		if (!caseSensitive) {
			value = value.toLowerCase();
			input = input.toLowerCase();
		}

		if (value === input) {
			return true;
		}

		return filterFn(input, value);
	};
}

/**
 * Creates a 'starts with' array filter function
 *
 * @param input {string} - value to filter on.
 * @param caseSensitive {boolean} - optional, defaults to false.
 * @returns {Function} - array filter function
 */
export function startsWithFilter(input, caseSensitive) {
	return createFilter(
		input,
		caseSensitive,
		(input, value) => value.substring(0, input.length) === input
	);
}

/**
 * Creates a 'contains' array filter function
 *
 * @param input {string} - value to filter on.
 * @param caseSensitive {boolean} - optional, defaults to false.
 * @returns {Function} - array filter function
 */
export function containsFilter(input, caseSensitive) {
	return createFilter(input, caseSensitive, (input, value) => value.indexOf(input) >= 0);
}
